import React from "react";

// Wrap case-insensitive matches of `q` in <mark> without a regex (data can hold
// regex metachars).
export const highlight = (text, q) => {
  if (!q) return text;
  const hay = text.toLowerCase();
  const needle = q.toLowerCase();
  const out = [];
  let i = 0;
  let pos;
  while ((pos = hay.indexOf(needle, i)) !== -1) {
    if (pos > i) out.push(text.slice(i, pos));
    out.push(
      <mark key={pos} className="text-inherit rounded-[2px] bg-[#F0B429]/30">
        {text.slice(pos, pos + needle.length)}
      </mark>
    );
    i = pos + needle.length;
  }
  if (i < text.length) out.push(text.slice(i));
  return out;
};
